module.exports = __webpack_public_path__ + "static/media/fullscreen-bg-video.9a6f8439.mp4";